var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./documents.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-04fbb4db\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./documents.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ficheSalarie/documents/documents.vue.html
// module id = +N2b
// module chunks = 2